<template>
  <div class="marp">
    <div class="content_marp">
      <div style="display: flex; align-items: center">
        <img
          @click="returns"
          src="../icon_left_grey@2X.png"
          style="width: 13px; height: 20px; cursor: pointer"
        />
        <span
          @click="returns"
          style="
            font-size: 22px;
            margin-left: 10px;
            cursor: pointer;
            color: #8c91ac;
          "
          >返回</span
        >
      </div>
      <div class="content">
        <h1 style="margin-top: 30px">易猎云开启RPO3.0时代</h1>
        <p>世纪什么最重要，是人才!</p>
        <p>
          2004年，电影《天下无贼》中葛优的一句经典台词，在时隔近20年后的今天依旧十分贴切。
        </p>
        <p>但与以往不同的是，如今的人才招聘方式却出现了翻天覆地般的变化。</p>
        <p>
          在2000年以前纸媒为王的时代，招聘信息主要来自当地的报纸，刚刚走出校门的大学生，或者心怀梦想的专业人才，通过对比报纸夹缝中一条条招聘信息来寻找自己心仪的职位。
        </p>
        <p>
          在2000年之后，随着第一波互联网浪潮的袭来，一批以网络招聘为核心业务的企业迅速成长。网络招聘所带来的红利，让这些企业至今仍是该赛道的有力竞争者
        </p>
        <p>
          而进入2010年代以来，伴随移动互联网快速发展和智能手机的普及，招聘渠道逐渐趋向互动化、社交化、数据化、智能化及数字化。同时，基于互联网技术赋能，将原有的人与信息的连接，变成了人与人的连接，人力资源得到了更高效地运用。
        </p>
        <p>
          眼下，随着各个产业市场的不断扩张，为了满足企业减轻人事负担、专注核心业务的需求，RPO（招聘流程外包）企业逐渐兴起。在2021年，RPO市场规模达到1765.6亿元，为人力资源市场中规模最大的板块。
        </p>
        <p>
          而在此当中，易猎云作为中国领先的RPO企业招聘管理系统综合解决方案供应商，也成长为该行业中难以被忽略的一家企业。
        </p>
        <h2>RPO3.0时代由易猎云开启</h2>
        <p>从RPO诞生之日到现在，已经历过三个阶段。”易猎云CTO贾明权说道"。</p>
        <p>
          易猎云方面认为，在PRO1.0时代，人力资源的数字化程度还处于低潮期，大部分企业依旧停留在EXCEL或共享文档来汇总人力信息。
        </p>
        <p>
          而随着经济上行及互联网技术的发展，为了提升人力资源管理的效率，在2.0时代，部分企业会引进ATS系统、SCRM系统甚至再镶嵌一个外呼吸系统，并将这些工具手工串联起来，形成一个初级形态的工作平台。
        </p>
        <p>
          这种工具平台勉强堪用，但是系统之间相互独立，没办法互通，尽管完成了人力管理的数字化雏形，但由于灵活性差，也给招聘顾问的工作带来了较大的工作负担。
        </p>
        <p>
          在此之后，基于对人力资源技术和招聘业务的长期实践和洞察，易猎云通过长期的技术投入和产品迭代，于2021年5月推出易猎云RPO工作平台旗舰版，该平台连接了主流招聘平台、短视频招聘平台、外呼能力以及微信通讯能力，将RPO数字化带入了3.0时代。
        </p>
        <img
          src="https://yilie.oss-cn-beijing.aliyuncs.com/front-yilieyun/official/ladder.png"
          style="width: 100%; height: 570px"
          alt=""
        />

        <p>
          区别于以往任何HR
          SaaS招聘管理系统，作为PRO3.0阶段数字化人力管理平台，易猎云RPO定位于帮助RPO企业建设一整套生产系统。
        </p>
        <p>
          贾明权向亿欧EqualOcean透露，在产品开发理念上，易猎云RPO平台存有“两个核心”：
        </p>
        <p>
          一个核心是以候选人为核心的面试各节点、全流程的保温服务和标签体系，提升求职者的招聘体验。另一个核心是以招聘顾问为核心的招聘助手、求职助手和企微助手，帮助招聘顾问实现跨平台实时沟通，提高对候选人的服务及响应能力。
        </p>
        <p>基于上述理念，易猎云在业务上基于RPO场景进行了多轮产品优化：</p>
        <p>
          首先，招聘顾问可以从招聘平台直接入库候选人信息，并可以一键外呼，降低了外呼出错概率，同时增添了对候选人邀约评价功能，方便对候选人的后续服务。
        </p>
        <p>
          其次，易猎云会将通话录音整合进系统，以帮助招聘顾问进行话术矫正。同时，还整合了双呼线路的通讯方案以更好地帮助招聘顾问和候选人建立连接。
        </p>
        <p>
          除此之外，易猎云也将自身定位于数字化招聘与人效提升平台，在提升招聘顾问效率方面，易猎云做到了招聘顾问行为的跨平台数字化，招聘顾问的工作行为可以非常方便的通过可视化图表的方式展示出来。
        </p>
        <p>
          易猎云方面认为，目前，招聘顾问的工作主要集中在招聘网站上和候选人的直聊沟通、易猎云系统内操作、微信沟通以及电话沟通四个方面。因此，易猎云将上述四个场景按照颜色区分，并按照时间顺序来呈现不同时间段内招聘顾问的工作内容，通过这张报表可以很好地反映出招聘顾问的工作习惯，便于其直属领导根据项目特性给予指导与优化。通过这样的热力图，也能方便地进行远程管理，管理者对招聘顾问工作方式与努力程度也能有更详细的了解。
        </p>

        <img
          src="https://yilie.oss-cn-beijing.aliyuncs.com/front-yilieyun/official/spot.png"
          style="margin: 35px 0 25px 205px"
          alt=""
        />
        <p style="text-align: center">招聘顾问效率可视化图</p>
        <h2>打通社交避障，提高数字化才是王道</h2>
        <p>
          不久前，贾明权就曾表示，易猎云作为市场上唯一一家专注于RPO行业的招聘管理系统，是真正从这个业务上生长出来的工作平台。
        </p>
        <p></p>
        <p>因此，易猎云和传统意义上的HR SaaS存在明显区别：</p>
        <p></p>
        <p>
          首先，易猎云更强调RPO场景中的人效提升和行为管理，而以往的HR
          SaaS更看重对企业内部流程的数字化；
        </p>
        <p></p>
        <p>
          其次，以往的HR
          SaaS更多地是向甲方用人单位开放的，其用户更多的是HR，而易猎云是面向RPO的，更侧重于RPO企业招聘场景以及招聘顾问全流程的数字化；
        </p>
        <p></p>
        <p>
          第三，易猎云除了提供ATS功能，同时又加上了SCRM、外呼系统，用户可以用易猎云进行RPO企业招聘场景下的全流程管理。但以往的HR
          SaaS只能做到一部分，不能覆盖RPO企业的所有需求。
        </p>
        <p></p>
        <p>
          由此可以看出，易猎云系统更加注重该系统的数字化提升以及打通社交避障的能力
        </p>
        <p></p>
        <p>
          易猎云方面表示，该系统如今能够把不同系统和平台做充分地连接和打通，包括在线招聘平台，短视频社交平台，工作社交平台，微信生态，外呼系统，短信平台等，彻底实现招聘业务流在平台上的全连接和数字化，实现RPO企业和候选人的微信/简历无缝连通，即能通过候选人微信找到候选人在平台上的简历，反之亦然。
        </p>
        <p></p>
      </div>
      <div class="footer_s">
        <p>报道摘自：亿欧</p>
        <p class="footer_s_s">
          点击
          <a href="https://www.iyiou.com/news/202205171031171" target="_blank"
            >阅读原文</a
          >
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "one",
  data() {
    return {};
  },
  mounted() {
    // console.log(window.location);
  },
  metaInfo: {
    title: "易猎云媒体报道-更适合RPO批量招聘场景的免费招聘管理系统",
    meta: [
      {
        name: "keywords",
        content: "易猎云，招聘管理系统，RPO，批量招聘，免费",
      },
      {
        name: "description",
        content: "易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统",
      },
    ],
  },
  created() {},
  mounted() {},
  methods: {
    returns() {
      this.$router.push({
        name: "About",
        params: {
          identification: true,
        },
      });
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="less" scoped>
.marp {
  height: max-content;
  padding-bottom: 50px;
  background: #e7f2ff;
  margin-top: 105px;

  .content_marp {
    height: max-content;
    width: 1200px;
    margin: auto;
    padding: 25px 53px;
    background: #fff;

    .content {
      h1 {
        font-size: 32px;
        color: #1d2754;
        line-height: 50px;
        font-weight: 600;
        text-align: center;
      }

      h2 {
        font-size: 26px;
        color: #1d2754;
        line-height: 30px;
        font-weight: 600;
        margin: 45px 0 20px 0;
      }

      p {
        font-size: 22px;
        margin: 15px 0;
        line-height: 40px;
        color: #686d85;
        text-indent: 2em;
        letter-spacing: 2px;
      }
    }

    .footer_s {
      display: flex;
      flex-direction: column;
      align-items: end;
      margin-right: 15px;

      p {
        font-size: 22px;
        margin: 15px 0;
        line-height: 30px;
        color: #686d85;
        letter-spacing: 2px;
      }

      .footer_s_s {
        margin-top: -10px;
        /*第一种状态： link （默认）正常状态（初始状态，不用鼠标去触碰）*/
        /*第二种状态： hover 鼠标放上去的时候（但不点击）*/
        /*第三种状态： active 点击的时候（鼠标还没放开）*/
        /*第四种状态： visited 点击之后（）*/

        /*a:link {*/
        /*  color: red;*/
        /*}*/

        a,
        a:hover {
          color: #ababab;
        }

        a,
        a:active {
          color: #ababab;
        }

        a,
        a:link {
          color: #0084ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article/one/one.vue